import { Question } from '../types';

export const verbFormsQuestions: Question[] = [
  {
    id: 'vf1',
    text: 'According to Al-Ajrumiyyah, how many types of verbs are there in Arabic?',
    type: 'single',
    options: [
      { id: 'a', text: 'Two types', isCorrect: false },
      { id: 'b', text: 'Three types', isCorrect: true },
      { id: 'c', text: 'Four types', isCorrect: false },
      { id: 'd', text: 'Five types', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that there are three types of verbs in Arabic: الماضي (past), المضارع (present), and الأمر (imperative).',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf2',
    text: 'According to Al-Ajrumiyyah, what is the sign of الفعل الماضي (the past tense verb)?',
    type: 'single',
    options: [
      { id: 'a', text: 'It accepts the prefix س or سوف', isCorrect: false },
      { id: 'b', text: 'It accepts تاء الفاعل المتحركة (the mobile ta of the subject)', isCorrect: false },
      { id: 'c', text: 'It accepts تاء التأنيث الساكنة (the still ta of femininity)', isCorrect: true },
      { id: 'd', text: 'It accepts نون التوكيد (the nun of emphasis)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the sign of الفعل الماضي (the past tense verb) is that it accepts تاء التأنيث الساكنة (the still ta of femininity), as in قامتْ (she stood).',
    ajrumiyyahReference: 'Chapter on Signs of Verbs (باب علامات الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf3',
    text: 'According to Al-Ajrumiyyah, what is the sign of الفعل المضارع (the present tense verb)?',
    type: 'single',
    options: [
      { id: 'a', text: 'It accepts the prefix س or سوف', isCorrect: true },
      { id: 'b', text: 'It accepts تاء الفاعل المتحركة (the mobile ta of the subject)', isCorrect: false },
      { id: 'c', text: 'It accepts تاء التأنيث الساكنة (the still ta of femininity)', isCorrect: false },
      { id: 'd', text: 'It begins with one of the letters ي، ت، أ، ن', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the sign of الفعل المضارع (the present tense verb) is that it accepts the prefix س or سوف, as in سيقوم (he will stand) or سوف يقوم (he will stand).',
    ajrumiyyahReference: 'Chapter on Signs of Verbs (باب علامات الأالأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf4',
    text: 'According to Al-Ajrumiyyah, what is the sign of فعل الأمر (the imperative verb)?',
    type: 'single',
    options: [
      { id: 'a', text: 'It accepts the prefix س or سوف', isCorrect: false },
      { id: 'b', text: 'It accepts تاء الفاعل المتحركة (the mobile ta of the subject)', isCorrect: false },
      { id: 'c', text: 'It accepts ياء المخاطبة (the ya of address)', isCorrect: false },
      { id: 'd', text: 'It accepts نون التوكيد (the nun of emphasis) with the meaning of request', isCorrect: true }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the sign of فعل الأمر (the imperative verb) is that it accepts نون التوكيد (the nun of emphasis) with the meaning of request, as in اضربَنّ (do hit).',
    ajrumiyyahReference: 'Chapter on Signs of Verbs (باب علامات الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf5',
    text: 'According to Al-Ajrumiyyah, what is المبني (the invariable verb)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The verb whose ending changes with the change of the governing agent', isCorrect: false },
      { id: 'b', text: 'The verb whose ending does not change with the change of the governing agent', isCorrect: true },
      { id: 'c', text: 'The verb that is built upon another verb', isCorrect: false },
      { id: 'd', text: 'The verb that is derived from a noun', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines المبني (the invariable verb) as the verb whose ending does not change with the change of the governing agent.',
    ajrumiyyahReference: 'Chapter on I\'rab (باب الإعراب)',
    topic: 'verb-forms'
  },
  {
    id: 'vf6',
    text: 'According to Al-Ajrumiyyah, what is المعرب (the declinable verb)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The verb whose ending changes with the change of the governing agent', isCorrect: true },
      { id: 'b', text: 'The verb whose ending does not change with the change of the governing agent', isCorrect: false },
      { id: 'c', text: 'The verb that is built upon another verb', isCorrect: false },
      { id: 'd', text: 'The verb that is derived from a noun', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines المعرب (the declinable verb) as the verb whose ending changes with the change of the governing agent.',
    ajrumiyyahReference: 'Chapter on I\'rab (باب الإعراب)',
    topic: 'verb-forms'
  },
  {
    id: 'vf7',
    text: 'According to Al-Ajrumiyyah, which verb form is always مبني (invariable)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'الفعل الماضي (the past tense verb)', isCorrect: true },
      { id: 'b', text: 'الفعل المضارع (the present tense verb)', isCorrect: false },
      { id: 'c', text: 'فعل الأمر (the imperative verb)', isCorrect: true },
      { id: 'd', text: 'All verb forms', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that الفعل الماضي (the past tense verb) and فعل الأمر (the imperative verb) are always مبني (invariable).',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf8',
    text: 'According to Al-Ajrumiyyah, which verb form can be معرب (declinable) or مبني (invariable) depending on certain conditions?',
    type: 'single',
    options: [
      { id: 'a', text: 'الفعل الماضي (the past tense verb)', isCorrect: false },
      { id: 'b', text: 'الفعل المضارع (the present tense verb)', isCorrect: true },
      { id: 'c', text: 'فعل الأمر (the imperative verb)', isCorrect: false },
      { id: 'd', text: 'All verb forms', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that الفعل المضارع (the present tense verb) can be معرب (declinable) or مبني (invariable) depending on certain conditions.',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf9',
    text: 'According to Al-Ajrumiyyah, when is الفعل المضارع (the present tense verb) مبني (invariable)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'When it is attached to نون النسوة (the nun of feminine plural)', isCorrect: true },
      { id: 'b', text: 'When it is attached to نون التوكيد (the nun of emphasis)', isCorrect: true },
      { id: 'c', text: 'When it is preceded by لم (lam)', isCorrect: false },
      { id: 'd', text: 'When it is preceded by لن (lan)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that الفعل المضارع (the present tense verb) is مبني (invariable) when it is attached to نون النسوة (the nun of feminine plural) or نون التوكيد (the nun of emphasis).',
    ajrumiyyahReference: 'Chapter on I\'rab (باب الإعراب)',
    topic: 'verb-forms'
  },
  {
    id: 'vf10',
    text: 'According to Al-Ajrumiyyah, what are the cases of الفعل المضارع (the present tense verb) when it is معرب (declinable)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'رفع (nominative)', isCorrect: true },
      { id: 'b', text: 'نصب (accusative)', isCorrect: true },
      { id: 'c', text: 'جرّ (genitive)', isCorrect: false },
      { id: 'd', text: 'جزم (jussive)', isCorrect: true }
    ],
    explanation: 'Al-Ajrumiyyah mentions that الفعل المضارع (the present tense verb) when it is معرب (declinable) can be in three cases: رفع (nominative), نصب (accusative), and جزم (jussive).',
    ajrumiyyahReference: 'Chapter on I\'rab (باب الإعراب)',
    topic: 'verb-forms'
  },
  {
    id: 'vf11',
    text: 'According to Al-Ajrumiyyah, what is the default case of الفعل المضارع (the present tense verb) when it is معرب (declinable)?',
    type: 'single',
    options: [
      { id: 'a', text: 'رفع (nominative)', isCorrect: true },
      { id: 'b', text: 'نصب (accusative)', isCorrect: false },
      { id: 'c', text: 'جرّ (genitive)', isCorrect: false },
      { id: 'd', text: 'جزم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that الفعل المضارع (the present tense verb) when it is معرب (declinable) is by default in the case of رفع (nominative) unless there is a governing agent that puts it in the accusative or jussive case.',
    ajrumiyyahReference: 'Chapter on I\'rab (باب الإعراب)',
    topic: 'verb-forms'
  },
  {
    id: 'vf12',
    text: 'According to Al-Ajrumiyyah, what are the governing agents that put الفعل المضارع (the present tense verb) in the نصب (accusative) case?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'أن (an)', isCorrect: true },
      { id: 'b', text: 'لن (lan)', isCorrect: true },
      { id: 'c', text: 'إذن (idhan)', isCorrect: true },
      { id: 'd', text: 'كي (kay)', isCorrect: true },
      { id: 'e', text: 'لم (lam)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the governing agents that put الفعل المضارع (the present tense verb) in the نصب (accusative) case are: أن (an), لن (lan), إذن (idhan), and كي (kay).',
    ajrumiyyahReference: 'Chapter on Nasb (باب النصب)',
    topic: 'verb-forms'
  },
  {
    id: 'vf13',
    text: 'According to Al-Ajrumiyyah, what are the governing agents that put الفعل المضارع (the present tense verb) in the جزم (jussive) case?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'لم (lam)', isCorrect: true },
      { id: 'b', text: 'لما (lamma)', isCorrect: true },
      { id: 'c', text: 'لام الأمر (the lam of command)', isCorrect: true },
      { id: 'd', text: 'لا الناهية (the prohibitive la)', isCorrect: true },
      { id: 'e', text: 'لن (lan)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the governing agents that put the الفعل المضارع (the present tense verb) in the جزم (jussive) case are: لم (lam), لما (lamma), لام الأمر (the lam of command), and لا الناهية (the prohibitive la).',
    ajrumiyyahReference: 'Chapter on Jazm (باب الجزم)',
    topic: 'verb-forms'
  },
  {
    id: 'vf14',
    text: 'According to Al-Ajrumiyyah, what are the types of الفعل (verb) in terms of transitivity?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'لازم (intransitive)', isCorrect: true },
      { id: 'b', text: 'متعدٍ (transitive)', isCorrect: true },
      { id: 'c', text: 'معلوم (active)', isCorrect: false },
      { id: 'd', text: 'مجهول (passive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the types of الفعل (verb) in terms of transitivity are: لازم (intransitive) and متعدٍ (transitive).',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf15',
    text: 'According to Al-Ajrumiyyah, what is الفعل اللازم (the intransitive verb)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The verb that requires a direct object', isCorrect: false },
      { id: 'b', text: 'The verb that does not require a direct object', isCorrect: true },
      { id: 'c', text: 'The verb that requires a subject', isCorrect: false },
      { id: 'd', text: 'The verb that does not require a subject', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines الفعل اللازم (the intransitive verb) as the verb that does not require a direct object, as in قام زيد (Zayd stood).',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf16',
    text: 'According to Al-Ajrumiyyah, what is الفعل المتعدي (the transitive verb)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The verb that requires a direct object', isCorrect: true },
      { id: 'b', text: 'The verb that does not require a direct object', isCorrect: false },
      { id: 'c', text: 'The verb that requires a subject', isCorrect: false },
      { id: 'd', text: 'The verb that does not require a subject', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines الفعل المتعدي (the transitive verb) as the verb that requires a direct object, as in ضرب زيد عمراً (Zayd hit Amr).',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf17',
    text: 'According to Al-Ajrumiyyah, how many types of الفعل المتعدي (the transitive verb) are there based on the number of objects they take?',
    type: 'single',
    options: [
      { id: 'a', text: 'One type', isCorrect: false },
      { id: 'b', text: 'Two types', isCorrect: false },
      { id: 'c', text: 'Three types', isCorrect: true },
      { id: 'd', text: 'Four types', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that there are three types of الفعل المتعدي (the transitive verb) based on the number of objects they take: those that take one object, those that take two objects, and those that take three objects.',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf18',
    text: 'According to Al-Ajrumiyyah, what is an example of a verb that takes one object?',
    type: 'single',
    options: [
      { id: 'a', text: 'ضرب (to hit)', isCorrect: true },
      { id: 'b', text: 'أعطى (to give)', isCorrect: false },
      { id: 'c', text: 'أعلم (to inform)', isCorrect: false },
      { id: 'd', text: 'ظن (to think)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah gives examples of verbs that take one object such as ضرب (to hit), as in ضرب زيد عمراً (Zayd hit Amr).',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf19',
    text: 'According to Al-Ajrumiyyah, what is an example of a verb that takes two objects that are not originally a subject and a predicate?',
    type: 'single',
    options: [
      { id: 'a', text: 'ضرب (to hit)', isCorrect: false },
      { id: 'b', text: 'أعطى (to give)', isCorrect: true },
      { id: 'c', text: 'ظن (to think)', isCorrect: false },
      { id: 'd', text: 'أعلم (to inform)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah gives examples of verbs that take two objects that are not originally a subject and a predicate such as أعطى (to give), as in أعطى زيد عمراً درهماً (Zayd gave Amr a dirham).',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf20',
    text: 'According to Al-Ajrumiyyah, what is an example of a verb that takes two objects that are originally a subject and a predicate?',
    type: 'single',
    options: [
      { id: 'a', text: 'ضرب (to hit)', isCorrect: false },
      { id: 'b', text: 'أعطى (to give)', isCorrect: false },
      { id: 'c', text: 'ظن (to think)', isCorrect: true },
      { id: 'd', text: 'قام (to stand)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah gives examples of verbs that take two objects that are originally a subject and a predicate such as ظن (to think), as in ظن زيد عمراً قائماً (Zayd thought Amr was standing).',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf21',
    text: 'According to Al-Ajrumiyyah, what is an example of a verb that takes three objects?',
    type: 'single',
    options: [
      { id: 'a', text: 'ضرب (to hit)', isCorrect: false },
      { id: 'b', text: 'أعطى (to give)', isCorrect: false },
      { id: 'c', text: 'ظن (to think)', isCorrect: false },
      { id: 'd', text: 'أعلم (to inform)', isCorrect: true }
    ],
    explanation: 'Al-Ajrumiyyah gives examples of verbs that take three objects such as أعلم (to inform), as in أعلم زيد عمراً بكراً فاضلاً (Zayd informed Amr that Bakr is virtuous).',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf22',
    text: 'According to Al-Ajrumiyyah, what is المبني للمعلوم (the active voice)?',
    type: 'single',
    options: [
      { id: 'a', text: 'When the subject is mentioned', isCorrect: true },
      { id: 'b', text: 'When the subject is omitted', isCorrect: false },
      { id: 'c', text: 'When the object is mentioned', isCorrect: false },
      { id: 'd', text: 'When the object is omitted', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines المبني للمعلوم (the active voice) as when the subject is mentioned, as in ضرب زيد عمراً (Zayd hit Amr).',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf23',
    text: 'According to Al-Ajrumiyyah, what is المبني للمجهول (the passive voice)?',
    type: 'single',
    options: [
      { id: 'a', text: 'When the subject is mentioned', isCorrect: false },
      { id: 'b', text: 'When the subject is omitted', isCorrect: true },
      { id: 'c', text: 'When the object is mentioned', isCorrect: false },
      { id: 'd', text: 'When the object is omitted', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines المبني للمجهول (the passive voice) as when the subject is omitted, as in ضُرِب زيد (Zayd was hit).',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf24',
    text: 'According to Al-Ajrumiyyah, how is the past tense verb changed to passive voice?',
    type: 'single',
    options: [
      { id: 'a', text: 'By adding a prefix', isCorrect: false },
      { id: 'b', text: 'By adding a suffix', isCorrect: false },
      { id: 'c', text: 'By changing the vowels', isCorrect: true },
      { id: 'd', text: 'By changing the consonants', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah explains that the past tense verb is changed to passive voice by changing the vowels, as in ضَرَبَ (he hit) to ضُرِبَ (he was hit).',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf25',
    text: 'According to Al-Ajrumiyyah, how is the present tense verb changed to passive voice?',
    type: 'single',
    options: [
      { id: 'a', text: 'By adding a prefix', isCorrect: false },
      { id: 'b', text: 'By adding a suffix', isCorrect: false },
      { id: 'c', text: 'By changing the vowels', isCorrect: true },
      { id: 'd', text: 'By changing the consonants', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah explains that the present tense verb is changed to passive voice by changing the vowels, as in يَضرِبُ (he hits) to يُضرَبُ (he is being hit).',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf26',
    text: 'According to Al-Ajrumiyyah, what is نائب الفاعل (the deputy of the subject)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The subject in the active voice', isCorrect: false },
      { id: 'b', text: 'The object that takes the place of the subject in the passive voice', isCorrect: true },
      { id: 'c', text: 'The verb in the passive voice', isCorrect: false },
      { id: 'd', text: 'The preposition in the passive voice', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines نائب الفاعل (the deputy of the subject) as the object that takes the place of the subject in the passive voice, as in ضُرِب زيد (Zayd was hit), where زيد is نائب الفاعل.',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf27',
    text: 'According to Al-Ajrumiyyah, what is the case of نائب الفاعل (the deputy of the subject)?',
    type: 'single',
    options: [
      { id: 'a', text: 'مرفوع (nominative)', isCorrect: true },
      { id: 'b', text: 'منصوب (accusative)', isCorrect: false },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that نائب الفاعل (the deputy of the subject) is always مرفوع (nominative).',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf28',
    text: 'According to Al-Ajrumiyyah, what happens to a verb that takes two objects when it is changed to passive voice?',
    type: 'single',
    options: [
      { id: 'a', text: 'The first object becomes نائب الفاعل (the deputy of the subject) and the second object remains منصوب (accusative)', isCorrect: true },
      { id: 'b', text: 'The second object becomes نائب الفاعل (the deputy of the subject) and the first object remains منصوب (accusative)', isCorrect: false },
      { id: 'c', text: 'Both objects become نائب الفاعل (the deputy of the subject)', isCorrect: false },
      { id: 'd', text: 'Both objects remain منصوب (accusative)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah explains that when a verb that takes two objects is changed to passive voice, the first object becomes نائب الفاعل (the deputy of the subject) and the second object remains منصوب (accusative), as in أُعطِي زيد درهماً (Zayd was given a dirham).',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf29',
    text: 'According to Al-Ajrumiyyah, what are the types of فعل الأمر (the imperative verb) based on its ending?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'صحيح الآخر (sound ending)', isCorrect: true },
      { id: 'b', text: 'معتل الآخر (weak ending)', isCorrect: true },
      { id: 'c', text: 'مضاعف (doubled)', isCorrect: true },
      { id: 'd', text: 'مهموز (hamzated)', isCorrect: true }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the types of فعل الأمر (the imperative verb) based on its ending are: صحيح الآخر (sound ending), معتل الآخر (weak ending), مضاعف (doubled), and مهموز (hamzated).',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  },
  {
    id: 'vf30',
    text: 'According to Al-Ajrumiyyah, what is the form of فعل الأمر (the imperative verb) for a second-person singular masculine from a sound verb?',
    type: 'single',
    options: [
      { id: 'a', text: 'افْعَلْ', isCorrect: true },
      { id: 'b', text: 'افْعَلِي', isCorrect: false },
      { id: 'c', text: 'افْعَلا', isCorrect: false },
      { id: 'd', text: 'افْعَلُوا', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the form of فعل الأمر (the imperative verb) for a second-person singular masculine from a sound verb is افْعَلْ, as in اضْرِبْ (hit!).',
    ajrumiyyahReference: 'Chapter on Verbs (باب الأفعال)',
    topic: 'verb-forms'
  }
];
